<template>
  <div class="otto-login">
    <Logo class="otto-login__title" />
    <form class="otto-login__form" v-on:submit.prevent="onSubmit">
      <p v-if="this.errorMsg" class="otto-text-error">{{errorMsg}}</p>
      <div class="otto-login__field">
        <label class="otto-login__label">EMAIL *</label>
        <input
          class="otto-login__input"
          type="text"
          v-model="email"
          @focus="onEmailFocus()"
          v-bind:class="{'otto-login__input--error': $v.email.$error}">
        <span v-if="$v.email.$error" class="otto-text-error">Please provide a valid email address.</span>
      </div>
      <div class="otto-login__field">
        <label class="otto-login__label">PASSWORD *</label>
        <input
          class="otto-login__input"
          type="password"
          v-model="password"
          v-bind:class="{'otto-login__input--error': $v.password.$error}"
          @focus="onPasswordFocus()"
        >
        <span v-if="$v.password.$error && !$v.password.minLength" class="otto-text-error">The password you entered is too short.</span>
        <span v-if="$v.password.$error && !$v.password.required" class="otto-text-error">Please enter your password.</span>
      </div>
     <p class="otto-login__forgot"><span class="otto-login__forgot-link" @click="forgotPassword">FORGOT PASSWORD?</span></p>
     <button :disabled="submitting" :class="{'otto-btn--disabled': submitting}" class="otto-login__btn"><span class="otto-btn-text">LOG IN</span></button>
    </form>
  </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';
import Logo from './Logo.svg';

export default {
  name: 'login',
  components: {
    Logo,
  },
  mounted() {
    this.$store.dispatch('clearState');
  },
  data() {
    return {
      email: '',
      password: '',
      errorMsg: '',
      submitting: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(6),
    },
  },
  methods: {
    onEmailFocus() {
      this.errorMsg = '';
      this.$v.email.$reset();
    },
    onPasswordFocus() {
      this.errorMsg = '';
      this.$v.password.$reset();
    },
    onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        this.submitting = true;
        this.login();
      }
    },
    showError(err) {
      this.errorMsg = err.message || err;
    },
    forgotPassword() {
      this.$router.push('/request_password');
    },
    login() {
      this.$store.dispatch('login', {
        email: this.email,
        password: this.password,
      }).then(() => {
        this.submitting = false;
        this.$router.push('/');
      }).catch((err) => {
        console.log('errror', err);
        this.submitting = false;
        this.showError(err);
      });
    },
  },
};
</script>

<style lang="sass" src="@/assets/styles/login.sass"></style>




// WEBPACK FOOTER //
// src/components/Login.vue